export enum EnumInstituicao {
    Nenhuma = -1,
    Itau = 341,
    BANCO_DO_BRASIL = 1,
    Safra = 422
}